export const getOrderDetailsByType = (type, response) => {
  switch (type) {
    case 'detailsHistoryPrepaid':
      return response?.prepaid;
    case 'detailsSimIpb':
      return response?.ipb;
    case 'detailPurchase':
      return response?.purchase;
    case 'DetailsPurchaseOrdersIpb':
      return {
        ...response?.purchase,
        ...response?.address,
      };
    case 'DetailsFailedTransactions':
      return response?.details;
    case 'DetailsVinculationOrders':
      return response;
    case 'AiraloDetails':
      return {
        ...response,
        ...response?.purchase_summary,
        ...response?.payment_information,
        ...response?.payment_method,
        ...response?.payer_information,
        ...response?.transaction_type,
      };
    default:
      return response?.payment_info;
  }
};
